import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Alert } from '../../../../common/models/alert.interface';

@Component({
    standalone: false,
    selector: 'q-alert-view',
    templateUrl: './alert-view.component.html',
    styleUrls: ['./alert-view.component.scss']
})
export class AlertViewComponent {
    @Output() onAlertClose = new EventEmitter<Alert>();
    @Input() alert: Alert;
    closeAlert(alert: Alert) {
        this.onAlertClose.emit(alert);
    }
}
